<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="ch3" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT" id="ch3"><samp class="SANS_Northwell_Clean_Regular_17">Approaching the blank page</samp></h1>
</header>
<p class="Body"><samp class="SANS_Menco_Light_17">Try not to be afraid, and be patient if this is your first approach to watercolor. You are bound to make some mistakes along the way, and you’re going to need to practice, process, and experience in order to grasp the techniques. You may get frustrated at times, and that’s why, above all, you must remember to enjoy yourself along the way!</samp></p>
<figure class="IMG-NOBOT"><img alt="" height="416" id="fig-pg12-2" src="images/pg12-2.jpg" width="523"/>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?027f757b